<template>
  <div>
    <h4 class="hide-on-small-only">
      Exportar Questionários
    </h4>
    <div class="card-panel">
      <form @submit.prevent="exportQuiz">
        <div class="row">
          <div class="col s12" style="padding: 0 !important">
            <div class="row" style="margin-bottom: 40px !important;">
              <div class="input-field col s12 m6">
                <select v-model="form.quiz">
                  <option value disabled selected
                    >Selecione um questionário</option
                  >
                  <option
                    v-for="quiz in quizzes"
                    :value="quiz.uuid"
                    :key="quiz.slug"
                    >{{ quiz.name }}</option
                  >
                </select>
                <span
                  class="helper-text"
                  v-show="formErros.customer"
                  style="color: #F44336;"
                  >{{ formErros.customer }}</span
                >
              </div>
              <div class="col s12 m6">
                <div class="row">
                  <div class="input-field col s12 m6">
                    <label for="init_date">Data Inicial</label>
                    <input
                      type="text"
                      name="init_date"
                      id="init_date"
                      v-model="form.init_date"
                      v-validate="'required|date'"
                      v-mask="'## / ## / ####'"
                      :class="{ invalid: errors.first('init_date') }"
                    />
                    <span
                      class="helper-text"
                      :data-error="errors.first('init_date')"
                    ></span>
                  </div>
                  <div class="input-field col s12 m6">
                    <label for="final_date">Data Final</label>
                    <input
                      type="text"
                      name="final_date"
                      id="final_date"
                      v-model="form.final_date"
                      v-validate="'required|date'"
                      v-mask="'## / ## / ####'"
                      :class="{ invalid: errors.first('final_date') }"
                    />
                    <span
                      class="helper-text"
                      :data-error="errors.first('final_date')"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="actions">
          <router-link
            class="waves-effect btn-large flat form-button"
            stag="a"
            :to="{ name: 'quizzes' }"
            >voltar</router-link
          >
          <div class="spacer"></div>
          <button
            class="waves-effect waves-light btn-large form-button"
            type="submit"
            :class="{ load: load }"
          >
            <feather v-if="load" type="loader" animation="spin" />
            <template v-else
              >Exportar
            </template>
          </button>
        </div>
      </form>

      <div class="download" v-if="download">
        <i class="material-icons">file_download</i>
        <div class="escrita">Seu arquivo está<br />sendo baixado</div>
      </div>
    </div>
  </div>
</template>

<script>
import mediaQuery from "@/services/mixins/mediaQuery";
import { mapState } from "vuex";

export default {
  name: "CreateOrUpdateForm",
  mixins: [mediaQuery],
  data: () => ({
    formErros: {
      customer: ""
    },
    searchText: "",
    instanceSelect: {},
    load: false,
    download: false,
    quizzes: [],
    form: {
      quiz: "",
      final_date: "",
      init_date: ""
    }
  }),
  async mounted() {
    const loader = this.$loading.show({
      loader: "spinner",
      width: 50,
      backgroundColor: "#000",
      color: "#fff"
    });

    const el = this.$el.querySelectorAll("select");
    this.instanceSelect = M.FormSelect.init(el);

    await this.getQuiz();
    loader.hide();
  },
  computed: {
    ...mapState("User", ["token"])
  },
  watch: {
    "form.quiz"() {
      this.formErros.customer = "";
      document.querySelector(".select-wrapper input.select-dropdown").style =
        "border-bottom: 1px solid #9e9e9e;";
    }
  },
  methods: {
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.csv");
      document.body.appendChild(link);
      link.click();

      this.download = true;

      setTimeout(() => {
        this.download = false;
      }, 2000);
    },
    async getQuiz() {
      try {
        const resp = await this.$http.get("quizzes?search=active:1");

        this.quizzes = resp.body.data.quizzes;

        this.instanceSelect[0].destroy();
        setTimeout(() => {
          const el = this.$el.querySelectorAll("select");
          this.instanceSelect = M.FormSelect.init(el);
        }, 0);
      } catch (e) {
        console.error(e);
      }
    },
    async exportQuiz() {
      try {
        await this.$validator.validateAll();

        if (!this.form.quiz) {
          this.formErros.customer = "Peenchimento Obrigatório";
          document.querySelector(
            ".select-wrapper input.select-dropdown"
          ).style = "border-bottom: 2px solid #F44336;";
        }

        if (!this.errors.items.length > 0) {
          const final_date = this.form.final_date.replace(/[^\d]+/g, "");
          const init_date = this.form.init_date.replace(/[^\d]+/g, "");

          const resp = await this.$http.get(
            `quizzes/export/${this.form.quiz}/${this.$moment(
              init_date,
              "DD/MM/YYYY"
            ).format("YYYY-MM-DD")}/${this.$moment(
              final_date,
              "DD/MM/YYYY"
            ).format("YYYY-MM-DD")}`
          );

          const exportRes = resp;
          this.forceFileDownload(exportRes);
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.download {
  position: absolute;
  left: 15px;
  bottom: 15px;
  padding: 30px;
  border-radius: 5px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  transition: 0.6s;

  i {
    font-size: 35px;
  }
  .escrita {
    margin-left: 20px;
    line-height: 100%;
  }
}

.animated {
  animation-duration: 0.5s;
}

.row {
  margin-bottom: 0 !important;
}
.actions {
  display: flex;
  justify-content: flex-end;
  .spacer {
    width: 16px;
    height: 24px;
  }

  @media #{$small-and-down} {
    flex-direction: column-reverse;
  }
}
.border-error {
  border: 2.4px solid #f44336;
}
</style>
